import { IEvent } from '../entities/IEvent';
import { EventImageConsentEnum } from '../enums/EventImageConsentEnum';
import { httpClient } from './helper/httpClient';

export interface ICreateEventParams {
  leadId: string;
  statusId: string;
  description: string;
  date?: string;
  locationId?: string | null;
  location?: string;
  birthId?: string | null;
  imageConsent?: EventImageConsentEnum;
  checklistId?: string;
}

export interface IUpdateEventParams {
  leadId?: string;
  statusId?: string;
  description?: string;
  date?: string;
  locationId?: string | null;
  location?: string;
  birthId?: string | null;
  imageConsent?: EventImageConsentEnum;
}

class EventService {
  private _baseURL = 'events';

  create(data: ICreateEventParams): Promise<IEvent> {
    return httpClient.post<null, IEvent>(this._baseURL, data);
  }

  getAll(): Promise<IEvent[]> {
    return httpClient.get<null, IEvent[]>(this._baseURL);
  }

  getById(id: string): Promise<IEvent> {
    return httpClient.get<null, IEvent>(`${this._baseURL}/${id}`);
  }

  update(id: string, data: IUpdateEventParams): Promise<void> {
    return httpClient.patch(`${this._baseURL}/${id}`, data);
  }

  delete(id: string): Promise<void> {
    return httpClient.delete(`${this._baseURL}/${id}`);
  }
}

export default new EventService();
